/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import HelperAccordion from "../../components/helperAccordion";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { useFontSize } from "../../components/contexts/AccessibilityContext";
import { fontSizeMap } from "../../utils/accessibilitySettings";
import OpportunityList from "../../components/OpportunityList";
import SideBar from "../../components/Sidebar";
import { FETCH_ALL_JOBS, FETCH_RECOMMENDED_JOBS } from "../../utils/constants";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import Form from "react-bootstrap/Form";
import useWindowWidth from "../../utils/windowWidth";
import { Spinner } from "react-bootstrap";

function Opportunity() {
  const { fontSize } = useFontSize();

  const [displayStatus, setDisplayStatus] = useState<"all" | "recommend">(
    "all"
  );

  //this is to toggle the header for mobile interface
  const [govt,setGovt] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [jobs, setJobs] = useState<any[]>([]);
  const [pageJobs, setPageJobs] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("government_job");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState("");

  const onPageChange = (newPage: any) => {
    if (newPage < 1 || newPage > totalPages) return; // Prevent going out of bounds
    setPage(newPage);
  };

  const navigate = useNavigate();

  const mainRef = useRef<HTMLHeadingElement>(null);
  const location = useLocation();

  function handleSearchText(event: any): void {
    setSearchText(event.target.value);
  }

  const handleCategoryChange = (category: any) => {
    setSelectedCategory(category);
    fetchAllJobs(category);
    setPage(1);
    if(category === 'government_job'){
      setGovt(true);
    } else {
      setGovt(false);
    }
  };

  function handleSearchSubmit(event: any): void {
    event.preventDefault();
    const query = searchText.trim().toLowerCase();
    if (!query) {
      setJobs(pageJobs);
      return;
    }
    const searchJobs = pageJobs.filter((job) => {
      return (
        job.company?.toLowerCase().includes(query) ||
        job.title?.toLowerCase().includes(query) ||
        job.resposibilites?.toLowerCase().includes(query) ||
        job.address?.toLowerCase().includes(query)
      );
    });
    setJobs(searchJobs);
  }

  const handleLinkClick = () => {
    // setActiveLink("File Upload");
    navigate("/opportunity/new");
  };

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    fetchAllJobs(selectedCategory);
    // setSearchText("");
    document.title = "Jobs Listing - Nclude Portal";
  }, []);

  useEffect(() => {
    fetchAllJobs(selectedCategory);
  }, [page]);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  function shuffleArray(array: any[]) {
    return array
      .map(value => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  }
  async function fetchAllJobs(categoryParam = ""): Promise<void> {
    setLoading(true);
    setLoadError("");
    setSearchText("");
    setDisplayStatus("all");
    const category = categoryParam || selectedCategory;
    try {
      let url = FETCH_ALL_JOBS + `?page=${page}&limit=${limit}`;
      if (category) {
        url += `&job_category=${category}`;
      }
      const response = await makeAuthenticatedGet(url);
      const temp = response.jobs.map((job: any) => ({
          ...job,
          markAsRead: false,
      }));
      const shuffledJobs = shuffleArray(temp);
      setJobs(shuffledJobs);
      setPageJobs(shuffledJobs);
      setTotalPages(Math.floor((response.totalJobCount - 1) / limit) + 1);
    } catch (error: any) {
      console.error("Error fetching jobs: ", error);
      setLoadError("We couldn’t load jobs right now. Please try again.");
      setJobs([]);
      setPageJobs([]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchRecommendedJobs(): Promise<void> {
    if (localStorage.getItem("resume") === "false") {
      navigate("/resumeforjobs");
      return;
    }
    setLoading(true);
    setLoadError("");
    setSearchText("");
    setDisplayStatus("recommend");
    try {
      const url = FETCH_RECOMMENDED_JOBS + `?page=${page}&limit=${limit}`;
      const response = await makeAuthenticatedGet(url);
      const temp = response.map((job: any) => ({
          ...job,
          markAsRead: false,
      }));
      setJobs(temp);
      setPageJobs(temp);
      setTotalPages(Math.floor((temp.length - 1) / limit) + 1);
    } catch (error: any) {
      console.error("Error fetching jobs: ", error);
      setLoadError("We couldn’t load recommended jobs right now. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  async function handleRecommendCheck() {
    setIsChecked(!isChecked);
  }

  useEffect(() => {
    if (isChecked) {
      fetchRecommendedJobs();
    } else {
      fetchAllJobs();
    }
  }, [isChecked]);

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header
        activePage="jobs"
        curr={0}
        changeCategory={handleCategoryChange}
      />}
      <div className="page-container">
        <SideBar activePage="Jobs" />
        <main className="doc-container jobs-page" id="main-content" tabIndex={-1}>
          <div>
            <h1
              className="display-title"
              ref={mainRef}
              tabIndex={-1}
            >
              {"Jobs Listing"}
            </h1>
          </div>
          <p className="jobs-intro">Browse current opportunities and expand any listing for full role details.</p>
          {/* <div className="border-2 border-white px-12 py-4 my-8">
            <nav
              aria-label="Browse selection navigation region"
              className="d-flex"
            >
              <button
                className={`py-4 mr-12 ${
                  displayStatus === "all"
                    ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                    : ""
                }`}
                onClick={() => fetchAllJobs}
              >
                All Jobs
              </button>
              <button
                className={`py-4 mr-12 ${
                  displayStatus === "recommend"
                    ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                    : ""
                }`}
                onClick={() => fetchRecommendedJobs}
              >
                Recommended Jobs
              </button>
            </nav>
          </div> */}
          <div className="d-flex items-center">
          {/* <a className="sr-only"
             tabIndex={0}
              href="#jobs-menu"
          >To move to jobs menu press enter</a> */}
            {/* <h2>{displayStatus === "all" ? "All Jobs" : "Recommended Jobs"}</h2> */}
            <div className="search-div">
              <form
                className="d-flex search-form"
                role="search"
                onSubmit={handleSearchSubmit}
              >
                <label htmlFor="job-search" className="visually-hidden">Search jobs</label>
                <input
                  id="job-search"
                  className="form-control me-2 search-input job-search"
                  type="search"
                  placeholder="Search jobs by company, location, responsibilities..."
                  aria-label="Search jobs by company, location, responsibilities"
                  aria-describedby="job-search-help"
                  value={searchText}
                  onChange={handleSearchText}
                />
                <button
                  className="btn search-btn job-search-btn"
                  type="submit"
                  aria-label="search jobs"
                >
                  Search
                </button>
              </form>
              <p className="search-help" id="job-search-help">Searches the jobs shown on this page.</p>
            </div>
          </div>
          <p className="results-summary" role="status" aria-live="polite">
            {!loading && !loadError ? `${jobs.length} ${jobs.length === 1 ? "job" : "jobs"} shown` : ""}
          </p>
          <div className="component-container">
            <div
              className="accessibility-header mb-8 md:mb-4 d-flex justify-content-between align-items-center"
            >
              {/* Tabs */}
              <div
                role="tablist"
                aria-label="Job categories"
                className="d-flex w-100"
                style={{ gap: "10px" }}
              >
                <button
                  type="button"
                  role="tab"
                  aria-selected={govt}
                  onClick={() => handleCategoryChange('government_job')}
                  className={`flex-fill ${govt ? "active-accessibility-header" : ""}`}
                >
                  Government Jobs
                </button>

                <button
                  type="button"
                  role="tab"
                  aria-selected={!govt}
                  onClick={() => handleCategoryChange('corporate_job')}
                  className={`flex-fill ${!govt ? "active-accessibility-header" : ""}`}
                >
                  Corporate Jobs
                </button>
              </div>

            </div>
            {/* Toggle on right */}
            {selectedCategory === "corporate_job" && (
              <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
                <label htmlFor="recommended-job">Recommended Jobs</label>

                <Form.Check
                  type="switch"
                  id="recommended-job"
                  checked={isChecked}
                  onChange={handleRecommendCheck}
                  role="switch"
                  aria-label="Toggle recommended jobs"
                />
              </div>
            )}
            {/* <div className="jobsDropdownContainer">
              <div className="mb-3 input-div">
                <h2 id="output-format" className="form-label">
                  Filter
                </h2>
                <select
                  className="form-control"
                  id="jobs-category"
                  name="job_category"
                  aria-label="Select jobs Category"
                  value={selectedCategory}
                  onChange={(event: any) =>
                    handleCategoryChange(event.target.value)
                  }
                  aria-labelledby="job-category"
                  required
                >
                  <option value="" disabled hidden>
                    Select job category
                  </option>
                  <option value={""}>All Jobs</option>
                  <option value={"government_job"}>Government Jobs</option>
                  <option value={"corporate_job"}>Corporate Jobs</option>
                </select>
              </div>
            </div> */}
            {loadError ? (
              <div className="jobs-error" role="alert">
                <p>{loadError}</p>
                <button
                  type="button"
                  onClick={() => displayStatus === "recommend" ? fetchRecommendedJobs() : fetchAllJobs(selectedCategory)}
                >
                  Try again
                </button>
              </div>
            ) : loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px", minWidth: "100%" }}>
                <Spinner
                  animation="border"
                  role="status"
                  variant="primary"
                  style={{ width: "4rem", height: "4rem" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <OpportunityList
                jobs={jobs}
                page={page}
                totalPages={totalPages}
                setPage={setPage}
                onPageChange={onPageChange}
                selectedCategory={selectedCategory}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Opportunity;
